<div class="state-control">
  <mat-form-field>
    <mat-label>State</mat-label>
    <input
      #control
      name="stateOrigin"
      type="text" 
      [(ngModel)]="stateValue"
      matInput
      [matAutocomplete]="autoStateOrigin"/>
  </mat-form-field>
  <mat-autocomplete (optionSelected)="stateValue = $event.option.value" #autoStateOrigin="matAutocomplete">
    <mat-option *ngFor="let state of stateOriginOptions$ | async" [value]="state">{{state}}</mat-option>
  </mat-autocomplete>
</div>
